<template>
  <component :is="layout">
    <router-view />
  </component>
  <cookiesConsent v-if="showCookiesConsent" />
</template>

<script>
import MainLayout from '../layouts/MainLayout'; // Your current layout
import AuthLayout from '../layouts/AuthLayout.vue'; // Create a new blank layout
import DefaultLayout from '../layouts/DefaultLayout.vue'; // Create a new blank layout
import cookiesConsent from '../nest_components/cookiesConsent.vue';

export default {
  name: "Layout",
  components: {
    MainLayout,
    AuthLayout,
    DefaultLayout,
    cookiesConsent
  },

  data() {
    return {
      showCookiesConsent: false
    };
  },

  mounted() {
    const consent = localStorage.getItem('cookies_consent');
    this.showCookiesConsent = !consent;
  },

  computed: {
    layout() {
      const routeLayout = this.$route.meta.layout || 'def';
      return routeLayout === 'auth' 
      ? AuthLayout 
      : routeLayout === 'main' 
      ? MainLayout 
      : DefaultLayout;
    }
  },
};
</script>